import { getEnv } from './env';

export const STATIC_ASSETS = {
  CLOUDFRONT_URL: getEnv('VUE_APP_CLOUDFRONT_URL'),
  ORG_PREFIX: 'organization',
  IMAGE_PATH: 'images',
  SITEDATA_PATH: 'regappsitedata',
  TRANSCRIPT_PATH: 'transcripts',
  SOCIAL_MEDIA_THUMBNAIL_PATH: 'public_images'
};

export function GET_IMAGE_PATH(orgId) {
  return `${STATIC_ASSETS.ORG_PREFIX}/${orgId}/${STATIC_ASSETS.IMAGE_PATH}/`;
}

export function IMAGE_SRC_PATH(str: string) {
  return `${getEnv('VUE_APP_ASSETS_CDN')}/${str}`;
}

export const BASE_URL = {
  REGISTRATION: getEnv('VUE_APP_API_REGISTRATION'),
  ON_DEMAND_EMBED: getEnv('VUE_APP_API_REGISTRATION')?.replace('events', 'embedscript'),
  SERIES_REGISTRATION: getEnv('VUE_APP_API_SERIES_REGISTRATION'),
  REPEATING_EVENT_REGISTRATION: getEnv('VUE_APP_API_REPEATING_EVENT_REGISTRATION'),
  WEBINAR_REGISTRATION: getEnv('VUE_APP_API_WEBINAR_REGISTRATION')
};

export const STATIC_ASSETS_BUCKET = getEnv('VUE_APP_S3_BUCKET');
export const STORE_REGION = getEnv('VUE_APP_AWS_STORE_REGION');
export const FILESTACK_API_KEY: string = getEnv('VUE_APP_FILESTACK_KEY') || '';

export function GET_SITEDATA_PATH(orgId) {
  return `${STATIC_ASSETS.ORG_PREFIX}/${orgId}/${STATIC_ASSETS.SITEDATA_PATH}/`;
}

export function GET_TRANSCRIPT_PATH(orgId: string, eventId: string) {
  return `${STATIC_ASSETS.ORG_PREFIX}/${orgId}/event/${eventId}/${STATIC_ASSETS.TRANSCRIPT_PATH}/`;
}
